import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Layout shell for all /signup/* routes.
 * The index redirect lives in signup.index.tsx.
 */
export const Route = createFileRoute("/$locale/{-$schoolyear}/signup")({
  component: SignupLayout,
});

function SignupLayout() {
  return <Outlet />;
}
